<template>
  <div>
    <list row-key="id" ref="list" unit="成本统计" :query-params="params" item-name="items" item-name2="items2"
      :layout="layout" size="small" show-summary :summary-method="summaryMethod"
      :show-query="showQuery" :get-data-func="getDataFunc" @reset="reset"
      >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="订单编号">
          <el-input v-model="DpName" class="long_inp" placeholder="请选择" readonly />
        </el-form-item>
       
        <el-form-item label="工单编号">
          <el-input v-model="params.BatchNumber" class="long_inp" placeholder="请选择" readonly />
        </el-form-item>
        <br>
      
        <el-form-item label="产品名称">
          <el-input v-model="ProductNo" class="long_inp" placeholder="请选择" readonly />
        </el-form-item>
        <br>
       
      </template>
      <!-- <template slot="table">
        <el-table-column prop="" label="产品名称" min-width="120px" />
        <el-table-column prop="" label="原材料/配件名称" min-width="120px" />
        <el-table-column prop="" label="条码" min-width="120px" />
        <el-table-column prop="" label="耗用数量" />
        <el-table-column prop="" label="单位" min-width="120px" />
        <el-table-column prop="" label="单价" />
        <el-table-column prop="" label="金额" /> -->
      
        <!-- slot[column] -->
        <!-- <slot name="column"></slot> -->
        <!--/ slot[column]-->
      <!-- </template> -->

        <!-- <template slot="table">
        <el-table-column prop="" label="加工阶段" min-width="120px" />
        <el-table-column prop="" label="产品/半成品名称" min-width="120px" />
        <el-table-column prop="" label="条码" />
        <el-table-column prop="" label="加工人员" min-width="120px" />
        <el-table-column prop="" label="加工数量" />
        <el-table-column prop="" label="单位" />
        <el-table-column prop="" label="单价" />
        <el-table-column prop="" label="金额" /> -->
      
        <!-- slot[column] -->
        <!-- <slot name="column"></slot> -->
        <!--/ slot[column]-->
      <!-- </template> -->
    </list>
 <!--   <multi-pick-dialog ref="batchMultiPick" in-dialog @select-multiple="setBatch" title="产品批号信息" key-id="BatchId"
      key-name="产品批号" key-value="BatchNumber" :func="proApi.productBatchNumberList" :default-value="batchArr" />
    <multi-pick-dialog ref="productMultiPick" in-dialog @select-multiple="setProduct" title="存货编码信息" key-id="ProductId"
      key-name="存货编码" key-value="ProductNo" :func="proApi.list" second-name="存货名称" second-value="ProductName"
      :default-value="productArr" />
    <multi-pick-dialog ref="trademarkMultiPick" in-dialog @select-multiple="setTrademark" title="商标编码信息"
      key-id="TrademarkNo" key-name="商标编码" key-value="TrademarkNo" :func="proApi.list" second-name="商标名称"
      second-value="TrademarkName" :default-value="trademarktArr" />
    <multi-pick-dialog ref="colorMultiPick" in-dialog @select-multiple="setColor" title="颜色编码信息" key-id="ColorId"
      key-name="颜色名称" key-value="ColorNo" :func="colorApi.list" second-name="颜色名称" second-value="ColorName"
      :default-value="colorArr" />-->
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/multiList";
import multiPickDialog from '@/components/common/multiPickDialog';
export default {
  mixins: [listMixin],
  components: { list, multiPickDialog },
  //关于multiPickDialog，keyId唯一Id，keyName/Value主要字段名称/值，func列表接口，secondName/Value第二列名称/值，select-multiple选择后的回调，defaultValue已选回显
  //关于multiList，isMerge：true时三层布局，false时二层布局，itemName第二层数组名称，itemName2第三层数组名称，layout表格上方信息布局，
  data() {
    return {
      api: require("@/api/ba/warehouse").default,
      saApi: require('@/api/sa/saOrder').default,
      unitApi: require('@/api/ba/tradeUnit').default,
      colorApi: require('@/api/ba/color').default,
      proApi: require('@/api/ba/product').default,
      params: {
        DpIds: [],
        //    TradeUnitIds: [],
        BatchIds: [],
        ProductIds: [],
        TrademarkIds: [],
        ColorIds: [],
        scrqs: "",
        scrqe: "",
        yjchrqs: "",
        yjchrqe: "",
        rkrqs: "",
        rkrqe: "",
        scchdl: 0,
      },
      scrq: [],
      yjchrq: [],
      rkrq: [],
      DpName: "",
      dpArr: [],
      //  unitArr: [],
      BatchNumber: "",
      batchArr: [],

      ProductNo: "",
      productArr: [],

      colorNo: "",
      colorArr: [],

      TrademarkNo: "",
      trademarktArr: [],
      tableDatas:[{Name:'物料成本'}]
    };
  },
  computed: {
    layout() {
      return [
        { key: "Name", span: 6 },
      
      ];
    }
  },
  beforeMount() {
    this.reset();
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        let Data = [];
        Data = [
          { Name: "物料成本", items: [{ BatchNo: "B001", ColorName: "红色", Quantity: 10 }, { BatchNo: "B002", ColorName: "绿色", Quantity: 20 }] },
          { Name: "人工成本", items: [{ ColorName: "白色" }] },
        ];
        resolve({ Data });
        
        // this.api.list({ ...params }).then((res) => {
        //   resolve(res);
        // });
      });
    },
       reset() {
      // let today = this.$commonJs.getToday();
      // this.scrq = [today.substr(0, 8) + "01", today];
      // this.params.scrqs = today.substr(0, 8) + "01";
      // this.params.scrqe = today;
      // this.yjchrq = [];
      // this.rkrq = [];
      // this.dpArr = [];
      // this.batchArr = [];
      // //----
      // this.ProductNo = "";
      // this.productArr = [];
      // this.trademarktArr = [];
      // this.colorArr = [];
    },
  /*  openBatchPick() {
      this.$refs.batchMultiPick.open();
    },
    openProductPick() {
      this.$refs.productMultiPick.open();
    },
    openTrademarkPick() {
      this.$refs.trademarkMultiPick.open();
    },
    openColorPick() {
      this.$refs.colorMultiPick.open();
    },
    setBatch(e, n, m) {
      this.batchArr = e;
      this.BatchNumber = n;
      this.params.BatchIds = m;
    },
    setProduct(e, n, m) {
      this.productArr = e;
      this.ProductNo = n;
      this.params.ProductIds = m;
    },
    setTrademark(e, n, m) {
      this.trademarkArr = e;
      this.trademarkNo = n;
      this.params.TrademarkIds = m;
    },
    setColor(e, n, m) {
      this.colorArr = e;
      this.Color = n;
      this.params.ColorIds = m;
    },
    onChange(e) {
      this.params.scrqs = e ? e[0] : "";
      this.params.scrqe = e ? e[1] : "";
    },
    onChange2(e) {
      this.params.yjchrqs = e ? e[0] : "";
      this.params.yjchrqe = e ? e[1] : "";
    },
    onChange3(e) {
      this.params.rkrqs = e ? e[0] : "";
      this.params.rkrqe = e ? e[1] : "";
    },
 */
    summaryMethod(params) {
      // const { columns, data } = params;
      // const sums = [];
      // columns.forEach((column, index) => {
      //   if (index === 0) {
      //     sums[index] = '小计';
      //     return;
      //   } else if (index > 5) {
      //     const values = data.map(item => Number(item[column.property]));
      //     if (!values.every(value => isNaN(value))) {
      //       sums[index] = values.reduce((prev, curr) => {
      //         const value = Number(curr);
      //         if (!isNaN(value)) {
      //           return prev + curr;
      //         } else {
      //           return prev;
      //         }
      //       }, 0);
      //       sums[index] = Math.floor(sums[index]);
      //     } else {
      //       sums[index] = '-';
      //     }
      //   } else {
      //     sums[index] = "-"
      //   }
      // });
      // return sums;
    },
  },
};
</script>
<style>
.long_inp .el-input__inner {
  width: 390px !important;
}
</style>